class WordPress {

    fetchHome = () => (
        // fetch(`./wp-json/components/gallery`)
        fetch(`${window.location.origin}/wp-json/wp/v2/pages/${window.location.host === 'localhost:8080' ? 32 : 23}`)
        .then(results => results.json())
        .then(page => ({
            gallery: page.acf.gallery_content,
            mapPins: page.acf.map_locations,
            defaultContent: page.content.rendered,
            page
        }))
    )
}

export default WordPress;